<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path
      d="M12.9566 18.3134L8.22186 13.1928H21V10.8072H8.22186L12.9566 5.6866L11.3971 4L4 12L11.3971 20L12.9566 18.3134Z"
      fill="currentColor"
    />
  </svg>
</template>
